import { objectSpread2 as _objectSpread2, taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React from 'react';
import { styled, TableRow } from '@mui/material';
import TableContext from '../TableContext.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';

var _templateObject;
var componentHeaderRow = createComponentSlot({
  name: "CinTable",
  slot: "HeaderRow"
});

var HeaderRowBase = function HeaderRowBase(_ref) {
  var data = _ref.data,
      dataKey = _ref.dataKey,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(TableRow, {
    className: componentHeaderRow.className
  }, /*#__PURE__*/React.createElement(TableContext.Provider, {
    value: {
      data: data,
      dataKey: dataKey,
      headerRow: true
    }
  }, typeof children === "function" ? children() : children));
};
/**
 * Renders a row for a table header
 */


HeaderRowBase.propTypes = {
  data: propTypes.arrayOf(propTypes.any),
  dataKey: propTypes.string,
  children: propTypes.oneOfType([propTypes.node, propTypes.func])
};
var HeaderRow = styled(HeaderRowBase, _objectSpread2(_objectSpread2({}, componentHeaderRow.styledOptions), {}, {
  skipSx: true,
  skipVariantsResolver: true
}))(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
var HeaderRow$1 = HeaderRow;

export { HeaderRow$1 as default };
